/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { ROUTES, setElementHeights } from '../../assets/constants/strings';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import HeaderBar from '../../components/HeaderBar';
import $ from 'jquery';
import RightNav from '../../components/RightNav';
import Menu from '../../components/Menu';
import FAQModal from '../../components/Modals/FAQ';
import SearchResult from '../../components/SearchResult';
import {
  clearDocSearch,
  clearSearch,
  Search,
} from '../../store/Document/documentActions';
import '../../components/Account/style.scoped.scss';

const SearchPage = ({
  user,
  Search,
  documents,
  searchResults,
  documentResults,
  docSearchLoading,
  pageSearchLoading,
  clearDocSearch,
  clearSearch,
  searchKeyword
}) => {
  // const { searchParam } = useParams();

  // const [searchValue, setSearchValue] = useState(
  //   searchParam !== null ? searchParam : ''
  // );
  const [searchValue, setSearchValue] = useState(null);
  const [searchAsSoonAsLoad, setSearchAsSoonAsLoad] = useState(false);
  const [userClosed, setUserClosed] = useState(false);

  const [isRightNavVisible, setIsRightNavVisible] = useState(
    window.innerWidth > 950
  );
  const [FAQuestion, setFAQuestion] = useState(0);

  useEffect(() => {
    setElementHeights();
  });

  // useEffect(() => {
  //   console.log(searchParam);

  //   if (searchParam && searchParam.length > 0) {
  //     const query = searchParam;
  //     const value = query.split('=')[1]; // "ML"
  //     console.log(value);
  //     setSearchValue(value);
  //   } else {
  //     setSearchAsSoonAsLoad(false);
  //   }
  // }, [searchParam]);

  useEffect(() => {
    if (searchKeyword !== null) {
      setSearchValue(searchKeyword);
    } else {
      setSearchAsSoonAsLoad(false);
    }
  }, [searchKeyword]);

  useEffect(() => {
    $(window).on('resize', setElementHeights);
    document.title = 'Search | RegulationCity';
    $('.tooltip').remove();

    // to prevent searching empty results, wait for load to finish
    if (!searchResults && searchKeyword && searchKeyword.length > 0 && documents) {
      Search(searchKeyword);
    }
    // user wanted to search on init but documents did not finish loading
    else if (
      !searchResults &&
      searchKeyword &&
      searchKeyword.length > 0 &&
      !documents
    ) {
      setSearchAsSoonAsLoad(true);
    }

    return () => {
      $('.tooltip').remove();
      clearSearch();
      clearDocSearch();
    };
  }, []);

  // logic to handle searching when documents have not finished loading
  useEffect(() => {
    if (
      !searchResults &&
      searchAsSoonAsLoad &&
      !docSearchLoading &&
      !pageSearchLoading &&
      documents
    ) {
      setSearchAsSoonAsLoad(false);
      Search(searchKeyword);
    }
  }, [documents, docSearchLoading, pageSearchLoading, searchResults]);

  const handleRightNav = (visible) => {
    setIsRightNavVisible(visible);
  };

  const handleSetFAQ = (question) => {
    setFAQuestion(question);
    $('#FAQModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const handleTagSelected = (value) => {
    setSearchValue(value);
    Search(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (documents && !searchResults && !docSearchLoading && !pageSearchLoading)
      Search(searchValue);
    else setSearchAsSoonAsLoad(true);
  };

  const handleClose = () => {
    setUserClosed(true);
  };

  const handleSearch = (e) => {
    // any should be => React.ChangeEvent<HTMLInputElement>
    setSearchValue(e.target.value);
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      Search(e.target.value);
    }
  };

  if (!user || (user && !user.isActive)) {
    return <Redirect to={ROUTES.LOGIN} />;
  }
  if (userClosed === true) {
    return <Redirect to={ROUTES.HOME} />;
  }
  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <Header />
          <HeaderBar pageTitle='Search' backGoesHome={true} />
        </div>
      </nav>

      <main
        role='main'
        className='wf-document pl-2 pr-3 mb-0'
        id='wf-search-page'
      >
        <div id='main-content' className='w-100'>
          {searchResults ||
          documentResults ||
          docSearchLoading ||
          pageSearchLoading ||
          searchAsSoonAsLoad ? (
            <SearchResult
              searchKeyword={searchValue}
              handleClose={handleClose}
              handleTagSelected={handleTagSelected}
              isSearchPage
              handleSearch={handleSearch}
            />
          ) : (
            <div className='wf-account__card wf-account__card__search'>
              <form onSubmit={handleSubmit}>
                <div className='form-group mb-0'>
                  <label
                    htmlFor='search-page-input'
                    onClick={() => console.log('searchResults', searchResults)}
                  >
                    Please enter a search term.
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Search...'
                    id='search-page-input'
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </div>
              </form>
            </div>
          )}
        </div>
        <RightNav
          accountPage
          handleVisibility={handleRightNav}
          handleSetFAQ={handleSetFAQ}
        />

        {!isRightNavVisible && <Menu accountPage handleSetFAQ={handleSetFAQ} />}
      </main>
      <Footer isDocument isCentered isAbsolute showLogo />
      <FAQModal question={FAQuestion} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  documents: state.client.documents,
  searchResults: state.document.searchResults,
  pageSearchLoading: state.document.pageSearchLoading,
  documentResults: state.document.documentResults,
  docSearchLoading: state.document.docSearchLoading,
  proccessesRunning: state.client.proccessesRunning,
  searchKeyword: state.search.searchValue,
});

const mapDispatchToProps = { Search, clearDocSearch, clearSearch };

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
